"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _Divider = require("./Divider.style");

var Divider = function Divider(_ref) {
  var className = _ref.className,
      style = _ref.style,
      theme = _ref.theme,
      type = _ref.type;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, (0, _Divider.lineDivider)(theme), type === 'line'), (0, _defineProperty2.default)({}, (0, _Divider.dotDivider)(theme), type === 'dot'), className),
    style: style
  });
};

Divider.propTypes = {
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(['line', 'dot'])
};
Divider.defaultProps = {
  style: {},
  className: null,
  type: 'line'
};

var _default = (0, _emotionTheming.withTheme)(Divider);

exports.default = _default;